/**
 * Tenants API
 */
import { apiClient } from './client'
import type { Tenant, TenantCreate, TenantUpdate } from '../types'

const ADMIN_BASE_PATH = '/api/admin/tenants'

export const tenantsApi = {
  list: async (): Promise<Tenant[]> => {
    const response = await apiClient.get<Tenant[]>(ADMIN_BASE_PATH)
    return response.data
  },

  get: async (tenantId: string): Promise<Tenant> => {
    const response = await apiClient.get<Tenant>(`${ADMIN_BASE_PATH}/${tenantId}`)
    return response.data
  },

  create: async (data: TenantCreate): Promise<Tenant> => {
    const response = await apiClient.post<Tenant>(ADMIN_BASE_PATH, data)
    return response.data
  },

  update: async (tenantId: string, data: TenantUpdate): Promise<Tenant> => {
    const response = await apiClient.put<Tenant>(`${ADMIN_BASE_PATH}/${tenantId}`, data)
    return response.data
  },
}
